import { classNames } from "../../../utils/classNames";
import React, { FC } from "react";
import style from "./Section.scss";

export interface SectionProps {
    className?: string;
}

export const Section: FC<SectionProps> = props => {
    return (
        <section className={classNames(style.section, { [`${props.className}`]: !!props?.className })} >
            {props.children}
        </section >
    );
};
